import type {ReactElement} from 'react';
import {useRef, useLayoutEffect, useState, memo} from 'react';
import {createPortal} from 'react-dom';
import styles from './markdown-renderer.module.scss';
import {attachSuffixContainer, renderAssistantChatMarkdownHtml} from '@Components/ai-chat-window/components/markdown-renderer/markdown-renderer.library';
import type {MarkdownRendererProps} from '@Components/ai-chat-window/components/markdown-renderer/markdown-renderer.types';

function MarkdownRenderer({content, suffix, toHtml = renderAssistantChatMarkdownHtml}: MarkdownRendererProps): ReactElement {
  const contentRef = useRef<HTMLDivElement>(null);
  const [suffixContainer, setSuffixContainer] = useState<HTMLElement | null>(null);

  useLayoutEffect(() => {
    const body = contentRef.current?.firstElementChild;

    if (!body || !suffix) {
      setSuffixContainer(null);

      return;
    }

    setSuffixContainer(attachSuffixContainer(body));
  }, [content, suffix]);

  const renderBody = (): ReactElement => {
    return <div dangerouslySetInnerHTML={{__html: toHtml(content)}} />;
  };

  return (
    <div ref={contentRef} className={styles.content}>
      {renderBody()}

      {suffixContainer && suffix ? createPortal(suffix, suffixContainer) : null}
    </div>
  );
}

export default memo(MarkdownRenderer);
